import { SearchState } from "react-instantsearch-core"

export const getFilterNumber = ({
  searchState,
  refinmentKey,
}: {
  searchState: SearchState
  refinmentKey?: string
}): number => {
  const searchStateCopy = { ...searchState }
  delete searchStateCopy.configure
  delete searchStateCopy.page
  delete searchStateCopy.query
  delete searchStateCopy.indices
  let nbFilter = 0
  Object.keys(searchStateCopy).forEach((key: string) => {
    Object.keys(searchStateCopy[key]).forEach((childKey: string) => {
      if (
        Array.isArray(searchStateCopy[key][childKey]) &&
        (refinmentKey
          ? childKey === refinmentKey || key === refinmentKey
          : true)
      ) {
        nbFilter += searchStateCopy[key][childKey].length
      } else if (
        searchStateCopy[key][childKey] &&
        (refinmentKey
          ? childKey === refinmentKey || key === refinmentKey
          : true)
      ) {
        nbFilter++
      }
    })
  })
  return nbFilter
}
